<template>
  <div>
    <!-- Snackbar for notifications -->
    <v-snackbar
      v-model="snackbar.active"
      centered
      timeout="2000"
      :color="snackbar.color"
    >
      <span v-html="snackbar.text"></span>
    </v-snackbar>

    <v-card flat>
      <v-row>
        <v-col cols="12" class="pt-0">
        <v-container :style="'max-width:'+containerMaxWidth+'px'" class="px-0 mt-0 pt-0">
          <div style="background-color: black!important; height: 35px;font-size: 14px;" class="pt-3 white--text white px-2 top-domain-bar">
            iBookrestaurant.com
            <div v-if="sharedCustomer && sharedCustomer.firstName" class="mb-1 float-right">
              {{greeting}} {{sharedCustomer.firstName}}!
            </div>
          </div>
          <v-card-title class="py-0 px-2 white" style="width:100%">
            <div class="brand-title">{{settings.brand||'&nbsp;'}}</div>
            <v-spacer></v-spacer>
            <v-btn icon @click="toggleHelp">
              <v-icon color="black">mdi-help-circle-outline</v-icon>
            </v-btn>
          </v-card-title>

          <!-- ═══════ MOBILE: unchanged, exactly as before ═══════ -->
          <template v-if="!isDesktop">
            <v-row>
              <v-col cols="12">
                <div v-show="showBooking">
                  <BookingTab
                    ref="bookingTab"
                    :customer="sharedCustomer"
                    :customer-id="customerId"
                    :is-active="showBooking"
                    :initial-open-bookings="openBookings"
                    :advertisers="advertisers"
                    @change-tab="showBooking = false; mainTab = 'Info'"
                    @wipe-out="dialog_wipeOut = true"
                  />
                </div>

                <v-tabs-items v-show="!showBooking" v-model="mainTab" touchless>
                  <v-tab-item value="Info" class="pt-0">
                    <InfoTab
                      ref="infoTab"
                      :customer-id="customerId"
                      :is-active="mainTab === 'Info'"
                      @change-tab="showBooking = true"
                      @open-bookings-loaded="openBookings = $event"
                      @advertisers-loaded="advertisers = $event"
                      @manage-reservations="onManageReservations"
                      @customer-updated="handleCustomerUpdate"
                      @detect-user-finished="handleDetectUserFinished"
                    />
                  </v-tab-item>
                  <v-tab-item value="Reviews" v-if="settings && settings.options && (settings.options.showTripAdvisorReviewsInDirectBooking==='1' || settings.options.showGoogleReviewsInDirectBooking==='1' || settings.options.showInternalReviewsInDirectBooking==='1')">
                    <ReviewsTab :customer-id="customerId" :is-active="mainTab === 'Reviews'" @change-tab="mainTab = $event" />
                  </v-tab-item>

                  <v-tab-item value="Delivery" v-if="settings && settings.options && (settings.options.showDelivery === '1' || settings.options.deliveryURL)">
                    <DeliveryTab :customer-id="customerId" :is-active="mainTab === 'Delivery'" @change-tab="mainTab = $event" />
                  </v-tab-item>

                  <v-tab-item value="Menu" v-if="settings && settings.options && (settings.options.showMenu === '1' || settings.options.menuURL)">
                    <MenuTab :customer-id="customerId" :is-active="mainTab === 'Menu'" @change-tab="mainTab = $event" />
                  </v-tab-item>

                  <v-tab-item value="FAQ">
                    <FaqTab :customer-id="customerId" :is-active="mainTab === 'FAQ'" @change-tab="mainTab = $event" />
                  </v-tab-item>

                  <v-tab-item value="Help">
                    <HelpTab :customer-id="customerId" :customer="sharedCustomer" :is-active="mainTab === 'Help'" @change-tab="mainTab = $event" />
                  </v-tab-item>

                </v-tabs-items>
              </v-col>
            </v-row>
          </template>

          <!-- ═══════ DESKTOP: Info (flexible) + Booking (fixed 420px), side by side ═══════ -->
          <template v-else>
            <div class="db-desktop-row">
              <div class="db-desktop-row__main">
                <v-tabs-items v-model="mainTab" touchless>
                  <v-tab-item value="Info" class="pt-0 overflow-y-hidden">
                    <InfoTab
                      :customer-id="customerId"
                      :is-active="mainTab === 'Info'"
                      @change-tab="mainTab = 'Info'"
                      :hide-cta="true"
                      @open-bookings-loaded="openBookings = $event"
                      @advertisers-loaded="advertisers = $event"
                      @manage-reservations="onManageReservations"
                      @customer-updated="handleCustomerUpdate"
                      @detect-user-finished="handleDetectUserFinished"
                    />
                  </v-tab-item>
                  <v-tab-item value="Reviews" v-if="settings && settings.options && (settings.options.showTripAdvisorReviewsInDirectBooking==='1' || settings.options.showGoogleReviewsInDirectBooking==='1' || settings.options.showInternalReviewsInDirectBooking==='1')">
                    <ReviewsTab :customer-id="customerId" :is-active="mainTab === 'Reviews'" @change-tab="mainTab = $event" />
                  </v-tab-item>

                  <v-tab-item value="Delivery" v-if="settings && settings.options && (settings.options.showDelivery === '1' || settings.options.deliveryURL)">
                    <DeliveryTab :customer-id="customerId" :is-active="mainTab === 'Delivery'" @change-tab="mainTab = $event" />
                  </v-tab-item>

                  <v-tab-item value="Menu" v-if="settings && settings.options && (settings.options.showMenu === '1' || settings.options.menuURL)">
                    <MenuTab :customer-id="customerId" :is-active="mainTab === 'Menu'" @change-tab="mainTab = $event" />
                  </v-tab-item>

                  <v-tab-item value="FAQ">
                    <FaqTab :customer-id="customerId" :is-active="mainTab === 'FAQ'" @change-tab="mainTab = $event" />
                  </v-tab-item>
                  
                  <v-tab-item value="Help">
                    <HelpTab :customer-id="customerId" :customer="sharedCustomer" :is-active="mainTab === 'Help'" @change-tab="mainTab = $event" />
                  </v-tab-item>

                </v-tabs-items>
              </div>

              <div class="db-desktop-row__booking">
                <BookingTab
                  ref="bookingTab"
                  :customer="sharedCustomer"
                  :customer-id="customerId"
                  :is-active="userDetected"
                  :initial-open-bookings="openBookings"
                  :advertisers="advertisers"
                  @change-tab="mainTab = 'Info'"
                  @wipe-out="dialog_wipeOut = true"
                />
              </div>
            </div>
          </template>

        </v-container>
        </v-col>
      </v-row>

      <!-- Fixed bottom navigation -->
      <!-- Fixed bottom navigation with horizontal sliding -->
      <div class="bottom-nav-bar d-flex justify-center" :style="'max-width:'+containerMaxWidth+'px;background-color:#e7e7e7;height:42px'">
        <!-- Few items: stretch to fill full width -->
        <div v-if="tabItems.length <= 3" class="d-flex" style="height:42px">
          <v-btn
            v-for="item in tabItems"
            :key="item"
            text tile :ripple="false"
            class="flex-grow-1 px-0"
            style="height:48px"
            @click="switchTab(item)"
          >
            <div class="d-flex flex-column align-center">
              <span
                class="text-uppercase font-weight-black"
                style="font-size:0.9rem"
                :class="mainTab === item ? 'black--text' : 'grey--text'"
              >{{$t(page+'.'+item)}}</span>
              <div v-if="mainTab === item" style="height:2px;width:32px;background:black;margin-top:3px;border-radius:2px"></div>
            </div>
          </v-btn>
        </div>

        <!-- Many items: scrollable slide group -->
        <v-slide-group
          v-else
          v-model="mainTab"
          show-arrows
          center-active
          mandatory
          style="height:48px"
        >
          <v-slide-item
            v-for="item in tabItems"
            :key="item"
            :value="item"
            v-slot="{ active, toggle }"
          >
            <v-btn
              text tile :ripple="false"
              class="px-4"
              style="height:48px;min-width:80px"
              @click="toggle(); switchTab(item)"
            >
              <div class="d-flex flex-column align-center">
                <span
                  class="text-uppercase font-weight-black"
                  style="font-size:0.75rem"
                  :class="active ? 'black--text' : 'grey--text'"
                >{{$t(page+'.'+item)}}</span>
                <div v-if="active" style="height:2px;width:32px;background:black;margin-top:3px;border-radius:2px"></div>
              </div>
            </v-btn>
          </v-slide-item>
        </v-slide-group>
      </div>
    </v-card>

    <!-- ─── WIPE OUT CONFIRMATION DIALOG ──────────────────────────── -->
    <v-dialog v-model="dialog_wipeOut" max-width="360" persistent>
      <v-card outlined class="app-dialog">
        <v-card-title class="app-dialog__title">
          <v-icon color="error" class="mr-2">mdi-delete-forever-outline</v-icon>
          <span class="text-subtitle-1 font-weight-bold">{{ $t(page+'.Wipe Out') || 'Wipe Out' }}</span>
        </v-card-title>
        <v-divider class="fw"></v-divider>
        <v-card-text class="text-body-2 pt-4">
          {{ $t(page+'.This will permanently delete your cookies and settings Are you sure') }}
        </v-card-text>
        <v-card-actions class="pb-4 px-4">
          <v-spacer></v-spacer>
          <v-btn outlined color="black" class="app-btn mr-2" @click="dialog_wipeOut = false">{{ $t(page+'.Cancel') }}</v-btn>
          <v-btn color="error" dark class="app-btn" @click="confirmWipeOut()">{{ $t(page+'.Wipe Out') || 'Wipe Out' }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ─── HELP DIALOG ──────────────────────────────────────────── -->
    <v-dialog v-model="dialog_help" max-width="480" scrollable>
      <v-card outlined class="app-dialog">
        <v-card-title class="app-dialog__title">
          <template v-if="helpStep === 1">
            <div class="brand-title-small">{{settings.brand||'&nbsp;'}}</div>
          </template>
          <template v-else>
            <span class="text-subtitle-1 font-weight-bold">{{helpTitles[helpStep]}}</span>
          </template>
          <v-spacer></v-spacer>
          <v-btn v-if="helpStep==1" fab icon small @click="dialog_help = false"><v-icon>mdi-close</v-icon></v-btn>
          <v-btn v-else fab icon small @click="helpStep = 1"><v-icon>mdi-arrow-left</v-icon></v-btn>
        </v-card-title>
        <v-divider class="fw"></v-divider>

        <v-card-text class="px-3 pt-3 pb-3">
          <v-stepper v-model="helpStep" flat class="elevation-0">
            <v-stepper-items>

              <!-- STEP 1: Usage info -->
              <v-stepper-content step="1" class="pa-0">
                <p class="text-body-2 font-weight-bold px-1 mb-3">{{ $t(page+'.Welcome, with this application you can') }}:</p>

                <div class="help-tile mb-2">
                  <v-icon class="mr-3" color="black">mdi-calendar-check-outline</v-icon>
                  <div>
                    <div class="text-body-2 font-weight-bold">{{ $t(page+'.Make a reservation') }}</div>
                    <div class="text-caption grey--text text--darken-1">{{ $t(page+'.Select date, covers and time slot, fill in your details and confirm') }}</div>
                  </div>
                </div>

                <div class="help-tile mb-2">
                  <v-icon class="mr-3" color="black">mdi-pencil-outline</v-icon>
                  <div>
                    <div class="text-body-2 font-weight-bold">{{ $t(page+'.Modify / Cancel / Query') }}</div>
                    <div class="text-caption grey--text text--darken-1">{{ $t(page+'.In Manage Reservation you can see, edit or cancel your reservations') }}</div>
                  </div>
                </div>

                <div class="help-tile mb-2">
                  <v-icon class="mr-3" color="error">mdi-link-variant</v-icon>
                  <div class="flex-grow-1">
                    <div class="text-body-2 font-weight-bold">{{ $t(page+'.Delete Account') }}</div>
                    <div class="text-caption grey--text text--darken-1 mb-2">{{ $t(page+'.Want to wipe out Cookies and Settings? Click here!') }}</div>
                    <v-btn small outlined color="error" class="app-btn" @click="wipeOut()">
                      <v-icon left small>mdi-delete-forever-outline</v-icon>
                      {{ $t(page+'.Wipe Out') || 'Wipe Out' }}
                    </v-btn>
                  </div>
                </div>

                <div class="help-tile mb-2">
                  <v-icon class="mr-3" color="black">mdi-link-variant</v-icon>
                  <div class="flex-grow-1">
                    <div class="text-body-2 font-weight-bold">{{ $t(page+'.Recover User') }}</div>
                    <div class="text-caption grey--text text--darken-1 mb-2">{{ $t(page+'.Changed Phone? Deleted Browser History or Cookies? You can re-join via OTP') }}</div>
                    <v-btn small outlined color="black" class="app-btn" @click="helpStep = 3">
                      <v-icon left small>mdi-link-variant</v-icon>
                      {{ $t(page+'.Get OTP') || 'Get OTP' }}
                    </v-btn>
                  </div>
                </div>

                <div class="help-tile mb-2">
                  <v-icon class="mr-3" color="black">mdi-credit-card-outline</v-icon>
                  <div>
                    <div class="text-body-2 font-weight-bold">{{ $t(page+'.Prepayment') }}</div>
                    <div class="text-caption grey--text text--darken-1">{{ $t(page+'.Some slots require a deposit via Stripe The card is charged or held depending on the restaurant policy') }}</div>
                    <div class="text-caption grey--text text--darken-1 mt-1">{{ $t(page+'.IMPORTANT:Cancellations and refunds are processed instantly, but your bank may take 3–10 business days to update your balance') }}</div>
                  </div>
                </div>

                <div class="help-tile mb-2">
                  <v-icon class="mr-3" color="green darken-1">mdi-whatsapp</v-icon>
                  <div>
                    <div class="text-body-2 font-weight-bold">{{ $t(page+'.WhatsApp') }}</div>
                    <div class="text-caption grey--text text--darken-1">{{ $t(page+'.You could receive a message related to your reservation') }}</div>
                  </div>
                </div>

                <div class="help-tile mb-2">
                  <v-icon class="mr-3" color="black">mdi-shield-account-outline</v-icon>
                  <div>
                    <div class="text-body-2 font-weight-bold">{{ $t(page+'.Your data') }}</div>
                    <div class="text-caption grey--text text--darken-1">{{ $t(page+'.Your data is stored securely and used only for booking management') }}</div>
                  </div>
                </div>

                <div class="help-tile mb-2">
                  <v-icon class="mr-3" color="error">mdi-incognito</v-icon>
                  <div class="flex-grow-1">
                    <div class="text-body-2 font-weight-bold">{{ $t(page+'.Anonymization') }}</div>
                    <div class="text-caption grey--text text--darken-1 mb-2">{{ $t(page+'.Anonymize your Name, Surname and phone with just one click') }}</div>
                    <v-btn small outlined color="error" class="app-btn" @click="helpStep = 2">
                      <v-icon left small>mdi-incognito</v-icon>
                      {{ $t(page+'.Anonymize Me') || 'Anonymize Me' }}
                    </v-btn>
                  </div>
                </div>

                <div class="help-tile">
                  <v-icon class="mr-3" color="black">mdi-silverware-variant</v-icon>
                  <div class="flex-grow-1">
                    <div class="text-body-2 font-weight-bold">{{ $t(page+'.Interested in the App?') }}</div>
                    <div class="text-caption grey--text text--darken-1 mb-2">{{ $t(page+'.Have a Restaurant, Pizzeria or interested investing?') }}</div>
                    <v-btn small outlined color="black" class="app-btn" href="https://wa.me/393505992731" target="_blank">
                      <v-icon left small>mdi-whatsapp</v-icon>
                      {{ $t(page+'.Contact Us') || 'Contact Us' }}
                    </v-btn>
                  </div>
                </div>
              </v-stepper-content>

              <!-- STEP 2: Anonymize -->
              <v-stepper-content step="2" class="pa-1">
                <v-alert type="warning" dense outlined class="text-body-2 mb-3">
                  {{ $t(page+'.This will permanently remove your personal data name phone email from our records Your booking history will be anonymized and cannot be recovered') || 'This will permanently remove your personal data (name, phone, email) from our records. Your booking history will be anonymized and cannot be recovered.' }}
                </v-alert>
                <v-text-field
                  v-model="helpConfirmText"
                  :label="$t(page+'.Type DELETE to confirm') || 'Type DELETE to confirm'"
                  outlined dense
                  hide-details
                  class="mb-3"
                ></v-text-field>
                <v-btn
                  block color="error" dark class="app-btn"
                  :disabled="helpConfirmText !== 'DELETE'"
                  :loading="helpLoading"
                  @click="doAnonymize()"
                >
                  <v-icon small left>mdi-incognito</v-icon>
                  {{ $t(page+'.Anonymize My Data') || 'Anonymize My Data' }}
                </v-btn>
              </v-stepper-content>

              <!-- STEP 3: Re-link account by phone + OTP verify -->
              <v-stepper-content step="3" class="pa-1">
                <template v-if="!helpOtpSent">
                  <p class="text-body-2 mb-3">{{ $t(page+'.If you changed device or cleared your data, enter your phone number to re-link your account') || 'If you changed device or cleared your data, enter your phone number to re-link your account.' }}</p>
                  <v-select
                    color="black"
                    dense
                    outlined
                    v-model="helpCountryCode"
                    :items="countries"
                    :label="$t(page+'.Country Code')"
                    hide-details
                    item-value="value"
                    :item-text="item => item.namel+' +'+item.value"
                  >
                    <template v-slot:item="slotProps">
                      <i :class="['mr-2','em',slotProps.item.flag]"></i>
                      {{slotProps.item.namel}} + {{slotProps.item.value}}
                    </template>
                    <template v-slot:selection="data">
                      <i :class="['mr-2','em',data.item.flag]"></i>
                      +{{data.item.value}}
                    </template>
                  </v-select>
                  <v-text-field
                    v-model="helpPhone"
                    :label="$t(page+'.WhatsApp number') || 'WhatsApp number'"
                    outlined dense
                    append-icon="mdi-whatsapp"
                    hide-details
                    reverse
                    class="my-3"
                    type="tel"
                    v-mask="'### ### ## ##'"
                  ></v-text-field>
                  <v-btn
                    block color="black" dark class="app-btn"
                    :disabled="!helpPhone || helpPhone.replace(/\s/g,'').length < 9"
                    :loading="helpLoading"
                    @click="doRelink()"
                  >
                    <v-icon small left>mdi-whatsapp</v-icon>
                    {{ $t(page+'.Get OTP') || 'Get OTP' }}
                  </v-btn>
                </template>

                <template v-else>
                  <v-alert type="success" dense outlined class="text-body-2 mb-3">
                    {{ $t(page+'.OTP sent to') || 'OTP sent to' }} <strong>{{ helpPhone }}</strong>
                  </v-alert>
                  <v-text-field
                    v-model="helpOtp"
                    :label="$t(page+'.Enter OTP code 9 digits') || 'Enter OTP code (9 digits)'"
                    outlined dense
                    append-icon="mdi-numeric"
                    type="text"
                    inputmode="numeric"
                    autocomplete="one-time-code"
                    placeholder="000-000-000"
                    v-mask="'###-###-###'"
                    class="mb-3"
                    reverse
                    :maxlength="11"
                    :minlength="11"
                    :loading="helpLoading"
                    :hint="helpOtpError"
                    :error="!!helpOtpError"
                    persistent-hint
                    @input="onOtpInput"
                  ></v-text-field>
                </template>
              </v-stepper-content>

              <!-- STEP 4: Success -->
              <v-stepper-content step="4" class="pa-1 text-center">
                <v-icon color="success" style="font-size:72px" class="mt-4">mdi-check-circle-outline</v-icon>
                <p class="text-h6 mt-3">{{ helpSuccessMsg }}</p>
                <v-btn outlined small color="black" class="app-btn mt-4" @click="dialog_help = false; helpStep = 1; showBooking = false; mainTab = 'Info'">
                  {{ $t(page+'.Close') || 'Close' }}
                </v-btn>
              </v-stepper-content>

              <!-- STEP 5: Failed -->
              <v-stepper-content step="5" class="pa-1 text-center">
                <v-icon color="error" style="font-size:72px" class="mt-4">mdi-close-circle-outline</v-icon>
                <p class="text-h6 mt-3">{{ helpOtpError }}</p>
                <v-btn outlined small color="black" class="app-btn mt-4" @click="dialog_help = false; helpStep = 1; showBooking = false; mainTab = 'Info'">
                  {{ $t(page+'.Close') || 'Close' }}
                </v-btn>
              </v-stepper-content>

            </v-stepper-items>
          </v-stepper>
        </v-card-text>
      </v-card>
    </v-dialog>  
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { loadBookingTranslations } from '@/i18n/index';
import InfoTab    from './tabs/InfoTab.vue'
import MenuTab    from './tabs/MenuTab.vue'
import FaqTab     from './tabs/FaqTab.vue'
import ReviewsTab from './tabs/ReviewsTab.vue'
import BookingTab from './tabs/BookingTab.vue'
import DeliveryTab from './tabs/DeliveryTab.vue'
import HelpTab    from './tabs/HelpTab.vue'
export default {
  components: { InfoTab, BookingTab, MenuTab, FaqTab, ReviewsTab, DeliveryTab, HelpTab },
  data() {
    return {
      page: "Booking",
      mainTab: 'Info',
      showBooking: false,
      customerId: null,
      openBookings: null,
      advertisers: null,
      booking: { "origin": null },
      snackbar: { active: false, color: 'success', text: '' },
      dialog_help: false,
      helpStep: 1,
      helpLoading: false,
      helpConfirmText: '',
      helpPhone: '',
      helpSuccessMsg: '',
      helpOtpSent: false,
      helpOtp: '',
      helpOtpError: '',
      helpOtpReady: false,
      helpCountryCode: 39,
      helpTitles: [null, null,'Anonymize','Get OTP','Success','Error'],
      dialog_wipeOut: false,
      sharedCustomer: null,
      userDetected: false
    }
  },
  created() {
    this.isDarkMod = false;
    const lang = (navigator.language || '').split('-')[0].toLowerCase();
    loadBookingTranslations(lang);
  },
  methods: {  
    handleCustomerUpdate(customerData) {
        this.sharedCustomer = customerData;
        if (customerData && customerData.customerId) {
            this.customerId = customerData.customerId;
        }
        this.userDetected = true;
    },
    handleDetectUserFinished() {
        this.userDetected = true;
    },
    onManageReservations() {
      this.showBooking = true;
      this.mainTab = 'Info';
    },
    switchTab(item) {
      if (this.$refs.bookingTab) {
        this.$refs.bookingTab.resetLoadedBooking()
      }
      this.showBooking = false
      this.mainTab = item
    },
    toggleHelp() {
      this.helpStep = 1
      this.helpConfirmText = ''
      this.helpPhone = ''
      this.helpOtpSent = false
      this.helpOtp = ''
      this.helpOtpError = ''
      this.dialog_help = true
    },
    wipeOut() {
      this.dialog_wipeOut = true
    },
    confirmWipeOut() {
      this.dialog_wipeOut = false
      localStorage.removeItem('customerId')
      location.reload()
    },
    async doAnonymize() {
      this.helpLoading = true
      try {
        const csrf = sessionStorage.getItem('csrf')
        const customerId = localStorage.getItem('customerId')
        const res = await this.$http.post('/booking/booking_stepper.php', {
          action: 'optOut',
          csrf,
          payload: { customerId }
        })
        const newCsrf = res.headers['x-csrf-token']
        if (newCsrf) sessionStorage.setItem('csrf', newCsrf)
        if (res.data.errorid === '0') {
          localStorage.removeItem('customerId')
          sessionStorage.clear()
          this.helpSuccessMsg = 'Your data has been anonymized.'
          this.helpStep = 4
        } else {
          this.helpSuccessMsg = res.data.message || 'An error occurred.'
          this.helpStep = 4
        }
      } catch (e) {
        console.error('doAnonymize error', e)
        this.helpSuccessMsg = 'Connection error. Please try again.'
        this.helpStep = 4
      } finally {
        this.helpLoading = false
      }
    },

    async doRelink() {
      this.helpLoading = true
      try {
        const res = await this.$http.post('/booking/booking_stepper.php', {
          action: 'sendOtp',
          payload: {
            countryCode: this.helpCountryCode,
            phone: this.helpPhone.replace(/\s/g, ''),
          }
        })
        const newCsrf = res.headers['x-csrf-token']
        if (newCsrf) sessionStorage.setItem('csrf', newCsrf)

        if (res.data.errorid === '0') {
          this.helpOtpReady = false
          this.helpOtpSent = true
          this.helpOtp = ''
          this.helpOtpError = ''
          setTimeout(() => { this.helpOtp = ''; this.helpOtpReady = true }, 300)
        }
        else
        {
          this.helpOtpError = res.data.message || 'Failed to send OTP.'
          this.helpStep = 5
        }
      } catch (e) {
        console.error('doRelink error', e)
        this.helpOtpError = 'Connection error. Please try again.'
      } finally {
        this.helpLoading = false
      }
    },

    async onOtpInput(val) {
      if (!this.helpOtpReady) return
      const digits = val ? String(val).replace(/-/g, '') : ''
      if (digits.length < 9) {
        this.helpOtpError = ''
        return
      }
      this.helpLoading = true
      this.helpOtpError = ''
      try {
        const otp = digits;
        const res = await this.$http.post('/booking/booking_stepper.php', {
          action: 'recoverAccount',
          payload: {
            phone: this.helpPhone.replace(/\s/g, ''),
            otp: otp,
            countryCode: this.helpCountryCode,
            customerId: localStorage.getItem('customerId')
          }
        })
        const newJwt = res.headers['authorization']
        if (newJwt) {
          this.$http.defaults.headers.common['Authorization'] = newJwt
          sessionStorage.setItem('jwt', newJwt)
        }
        const newCsrf = res.headers['x-csrf-token']
        if (newCsrf) sessionStorage.setItem('csrf', newCsrf)

        if (res.data.errorid === '0' && res.data.payloads && res.data.payloads.rc>0)
        {
          const customerId = res.data.payloads.customerId
          if (customerId) localStorage.setItem('customerId', customerId)
          this.helpSuccessMsg = 'Account re-linked successfully!'
          this.helpStep = 4
        }
        else
        {
          this.helpOtpError = res.data.message || 'Invalid OTP. Please try again.'
          this.helpStep = 5
        }
        setTimeout(() => { window.location.reload() }, 2500)
      } catch (e) {
        console.error('onOtpInput error', e)
        this.helpOtpError = 'Connection error. Please try again.'
      } finally {
        this.helpLoading = false
      }
    },
  },
  computed: {
    ...mapGetters(['settings', 'countries']),
    greeting() {
      const hour = new Date().getHours()
      return hour < 16 ? this.$t(this.page + '.Good Morning') : this.$t(this.page + '.Good Evening')
    },
    isDesktop() {
      return this.$vuetify.breakpoint.mdAndUp // >= 960px
    },
    containerMaxWidth() {
      return this.isDesktop ? 1440 : 420
    },    
    tabItems() {
      const options= this.settings && this.settings.options
      const items = ['Info']
      if (options && (options.showTripAdvisorReviewsInDirectBooking==='1' || options.showGoogleReviewsInDirectBooking==='1' || options.showInternalReviewsInDirectBooking==='1' )) items.push('Reviews')
      if (options && (options.showDelivery==='1' || options.deliveryURL )) items.push('Delivery')
      if (options && (options.showMenu==='1' || options.menuURL)) items.push('Menu')
      items.push('FAQ')
      items.push('Help')
      return items
    },
    isDarkMod: {
      get() { return this.dark; },
      set(value) {
        this.$vuetify.theme.dark = value;
        this.$store.dispatch("scheme/setDarkTheme", value);
      }
    },
  }
}
</script>

<style scoped>
.bottom-nav-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 64px;
  background: white;
  border-top: 1px solid #e0e0e0;
  z-index: 6;
  max-width: 420px;
  width: 100%;
  border-radius: 0px !important;
  left: 50% !important;
  transform: translateX(-50%);
}

.minWidth-30 { min-width: 20px!important; }

.top-domain-bar {
  font-size: 11px;
  border-bottom: 1px solid #ddd !important;
}

.brand-title {
  font-family: Roboto, sans-serif;
  font-weight: 600;
  font-size: 26px;
  color: #020e18;
}

.brand-title-small {
  font-family: Roboto, Arial, sans-serif;
  font-weight: 400;
  font-size: 22px;
}

.tab-indicator {
  height: 2px;
  width: 32px;
  background: black;
  margin-top: 3px;
  border-radius: 2px;
}

/* Shared dialog styling — bordered, no shadow, matches tile aesthetic */
.app-dialog {
  border-radius: 16px !important;
  border-color: #e0e0e0 !important;
}

.app-dialog__title {
  display: flex;
  align-items: center;
  padding: 16px 16px 12px 16px !important;
}

.app-btn {
  border-radius: 10px !important;
}

/* Help dialog list rows redone as bordered tiles instead of plain v-list-items */
.help-tile {
  display: flex;
  align-items: flex-start;
  border: 1.5px solid #e0e0e0;
  border-radius: 12px;
  padding: 12px;
}
</style>

<style scoped>
.db-desktop-row {
  display: flex;
  align-items: flex-start;
  gap: 24px;
}

.db-desktop-row__main {
  flex: 1 1 auto;
  min-width: 0;
}

.db-desktop-row__booking {
  flex: 0 0 600px;
  max-width: 600px;
  border: 1.5px solid #e0e0e0;
  overflow: hidden;
}
</style>

